module.exports = __webpack_public_path__ + "media/img/pages/profile/hslu ger 10-6cd2acefc58bce3c1c9e7a9424912b52.webp";